import { fetchMonthMetaData } from 'js/crossword/fetchMonthMetaData';
import { getLoadData } from 'js/crossword/saveRestorePuzzle';

export interface ICalendarDayConfig {
  dayNumber: number;
  puzzleUrl: string | null;
  fillRate: number | null;
  currentDay: boolean;
  currentMonth: boolean;
  completed: boolean;
  author: string | null;
  date: string | null;
  puzzleId: string | null;
}

export async function getCalendarEntries(
  year: number,
  month: number,
  currentPuzzleId: string,
): Promise<ICalendarDayConfig[]> {
  const monthMetaData = await fetchMonthMetaData(year, month);
  const dates = getCalendarDates(year, month, 6 * 7);

  return dates.map((date) => {
    const formatedDate = dateToYYYYMMDD(date);
    const metaData = monthMetaData.find((v) => v.date === formatedDate) || null;

    return {
      dayNumber: date.getDate(),
      puzzleUrl: metaData ? metaData.feedUrl : null,
      puzzleId: metaData ? getPuzzleIDFromURL(metaData.feedUrl) : null,
      fillRate: metaData ? getFillRateForURL(metaData.feedUrl) : 0,
      currentDay: metaData ? getPuzzleIDFromURL(metaData.feedUrl) === currentPuzzleId : false,
      currentMonth: date.getMonth() === month,
      completed: metaData ? getCompletedForURL(metaData.feedUrl) : false,
      author: metaData ? metaData.author : null,
      date: metaData ? metaData.date : null,
    };
  });
}

function getFillRateForURL(url: string): number {
  const id = getPuzzleIDFromURL(url);
  if (id === null) return 0;
  const data = getLoadData(id);
  return data ? data.fillRate : 0;
}

function getCompletedForURL(url: string): boolean {
  const id = getPuzzleIDFromURL(url);
  if (id === null) return false;
  const data = getLoadData(id);
  return data ? data.completed || false : false;
}

function getPuzzleIDFromURL(url: string): string | null {
  try {
    return url.split('/').pop()!.split('.')[0];
  } catch (e) {
    console.warn(e);
    return null;
  }
}

export function getCalendarDates(year: number, month: number, numberOfDays: number): Date[] {
  const result: Date[] = [];

  let currentDate = getFirstMondayInCalendar(new Date(year, month, 1));

  for (let i = 0; i < numberOfDays; i++) {
    result.push(currentDate);
    currentDate = getNextDay(currentDate);
  }

  return result;
}

function getFirstMondayInCalendar(firstDayOfMonth: Date): Date {
  while (firstDayOfMonth.getDay() !== 1) {
    firstDayOfMonth.setDate(firstDayOfMonth.getDate() - 1);
  }
  return firstDayOfMonth;
}

function getNextDay(date: Date): Date {
  const newDate = new Date(date.getTime());
  newDate.setDate(date.getDate() + 1);
  return newDate;
}

export function dateToYYYYMMDD(d: Date): string {
  const year: string = d.getFullYear().toString();
  const month: string = (d.getMonth() + 1).toString().padStart(2, '0');
  const day: string = d.getDate().toString().padStart(2, '0');
  return [year, month, day].join('-');
}
